import {
  LIST_TITLE_REQUEST,
  LIST_TITLE_SUCCESS,
  LIST_TITLE_FAIL,
  LIST_TITLE_SUMMARY_REQUEST,
  LIST_TITLE_SUMMARY_SUCCESS,
  LIST_TITLE_SUMMARY_FAIL,
  CREATE_TITLE_REQUEST,
  CREATE_TITLE_SUCCESS,
  CREATE_TITLE_FAIL,
  DETAIL_TITLE_REQUEST,
  DETAIL_TITLE_SUCCESS,
  DETAIL_TITLE_FAIL,
  UPDATE_TITLE_REQUEST,
  UPDATE_TITLE_SUCCESS,
  UPDATE_TITLE_FAIL,
  DELETE_TITLE_REQUEST,
  DELETE_TITLE_SUCCESS,
  DELETE_TITLE_FAIL
} from '../../constants/titles'

const initialState = {
  loading: false,
  titles: [],
  title: {},
  titlesSummary: [],
  pageable: {},
  error: null
}

const titleReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_TITLE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_TITLE_SUCCESS:
      return {
        ...state,
        loading: false,
        titles: action.payload,
        pageable: action.pageable
      }
    case LIST_TITLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        titles: []
      }
    case LIST_TITLE_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_TITLE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        titlesSummary: action.payload
      }
    case LIST_TITLE_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_TITLE_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_TITLE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        titles: [...state.titles, action.payload]
      }
    case CREATE_TITLE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_TITLE_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_TITLE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        title: action.payload
      }
    case DETAIL_TITLE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_TITLE_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_TITLE_SUCCESS:
      const updatedTitle = action.payload
      const updateFindIndexTitle = state.titles.findIndex(title => title.id === updatedTitle.id)
      const updatedTitles = [...state.titles]
      updatedTitles[updateFindIndexTitle] = updatedTitle

      return {
        ...state,
        loadingUpdate: false,
        titles: updatedTitles
      }
    case UPDATE_TITLE_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_TITLE_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_TITLE_SUCCESS:
      const deletedTitleId = action.payload
      const deletedFindIndexTitle = state.titles.findIndex(title => title.id === deletedTitleId)
      const deletedTitles = [...state.titles]
      deletedTitles.splice(deletedFindIndexTitle, 1)

      return {
        ...state,
        loadingDelete: false,
        titles: deletedTitles
      }
    case DELETE_TITLE_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default titleReducer